import React from 'react'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { ReloadIcon } from '@radix-ui/react-icons'
import { X } from 'lucide-react'

const DataTableToolbar = ({ mutate, search, onSearchChange }) => {
  return (
    <div className="flex items-center justify-between gap-4">
      <Button variant="outline" onClick={() => mutate()}>
        <ReloadIcon className="h-4 w-4 mr-2" />
        Refetch
      </Button>
      <div className="relative">
        <Input
          id="tonings-search"
          type="text"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Search loaded tonings"
          className="w-56"
        />
        {search ? (
          <Button
            type="button"
            variant="ghost"
            size="sm"
            title="Clear search"
            onClick={() => onSearchChange('')}
            className="absolute right-1 top-1/2 h-6 w-6 -translate-y-1/2 p-0"
          >
            <X className="h-4 w-4" />
          </Button>
        ) : null}
      </div>
    </div>
  )
}

export default DataTableToolbar
